<template>
  <div
    id="kt_body"
    class="kt-body kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch"
  >
    <div
      id="kt_content"
      class="kt-content kt-content--fit-top kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
    >
      <!-- begin:: Subheader -->
      <div id="kt_subheader" class="service-header kt-subheader kt-grid__item">
        <div class="kt-container">
          <div class="kt-subheader__main header-section">
            <h3 class="kt-subheader__title">
              ค้นหา email ในข้อความ
            </h3>
            <div class="subtitle">
              <div class="col-xl-6">
                คืน email และตำแหน่งของ email ในข้อความให้อัตโนมัติ
              </div>
              <div class="col-xl-6">
                <div class="kt-subheader__main">
                  <div class="kt-infobox__section service-info">
                    <div
                      class="kt-infobox__subtitle kt-font-bold check-box-icon"
                    >
                      <i class="fa fa-check-circle" />
                    </div>
                    <div>
                      <div class="kt-infobox__subtitle kt-font-bold">
                        คืนตำแหน่งของข้อมูล
                      </div>
                      <!-- <div class="kt-infobox__content">
                        เช่น ตำบล อยู่ตำแหน่งที่ 3 ถึง 10 ของข้อความ
                        เพื่อให้นำไปต่อยอดได้หลากหลาย
                      </div> -->
                    </div>
                  </div>
                  <div class="kt-infobox__section api-doc">
                    <a
                      href="https://nlp.insightera.co.th/docs/v1.0/#!/nlp/post_nlp_extract_email"
                      target="_blank"
                      class="kt-font-bolder api-doc-link"
                      @click="
                        trackCustomEvent({
                          action: 'clicked',
                          target: 'links_content',
                          linkTo: 'docs',
                        })
                      "
                    >API Document</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end:: Subheader -->

      <!-- begin:: Content -->
      <div class="kt-container kt-grid__item kt-grid__item--fluid">
        <div class="row">
          <div class="col-xl-6">
            <!--begin::Portlet-->
            <div class="kt-portlet kt-portlet--height-fluid">
              <!--begin::Form-->
              <form class="kt-form kt-form--label-right">
                <div class="kt-portlet__body">
                  <div class="kt-infobox">
                    <div class="kt-infobox__header">
                      <h3 class="kt-infobox__title">
                        พิมพ์ข้อความที่มี email ทีนี่
                      </h3>
                    </div>
                    <div class="kt-infobox__body">
                      <!-- Address :: Text Input -->
                      <div class="form-group kt-margin-b-15">
                        <!-- <label for="exampleTextarea">Example textarea</label> -->
                        <textarea
                          id="exampleTextarea"
                          v-model="text"
                          class="form-control"
                          rows="10"
                          @input="
                            trackCustomEvent({
                              event: 'input',
                              action: 'type',
                              target: 'textarea_content',
                              value: text,
                            })
                          "
                        />
                      </div>
                      <div class="kt-form__actions kt-form__actions--right">
                        <div class="row">
                          <div class="col kt-align-left">
                            <button
                              type="button"
                              class="btn btn-secondary"
                              :disabled="processing"
                              @click="
                                trackCustomEvent({
                                  action: 'clicked',
                                  target: 'random_content',
                                });
                                random();
                              "
                            >
                              Random
                            </button>
                          </div>
                          <div class="col kt-align-right">
                            <button
                              type="button"
                              class="btn btn-primary kt-spinner--left kt-spinner--sm kt-spinner--light"
                              :class="{ 'kt-spinner': processing }"
                              :disabled="processing"
                              @click="
                                trackCustomEvent({
                                  action: 'clicked',
                                  target: 'analyze_content',
                                });
                                debounceSubmit();
                              "
                            >
                              Analyze
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!--end::Portlet-->
          </div>
          <div class="col-xl-6">
            <!--Begin:: Portlet-->
            <div class="kt-portlet kt-portlet--height-fluid">
              <div class="kt-portlet__body">
                <div class="kt-form kt-form--label-right">
                  <div class="kt-infobox">
                    <div class="kt-infobox__header">
                      <h3 class="kt-infobox__title">
                        ผลการวิเคราะห์
                      </h3>
                    </div>
                    <!-- Address -->
                    <div class="kt-infobox__body">
                      <div class="kt-infobox__section">
                        <div class="kt-infobox__content">
                          <div v-for="(email, idx) in emails" :key="email" class="form-group form-group-xs row">
                            <label class="col-3 col-form-label">email {{ idx+1 }}:</label>
                            <div class="col-9">
                              <span
                                class="form-control-plaintext kt-font-bold"
                              >{{ email }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="kt-infobox__section">
                        <h3 class="kt-infobox__subtitle kt-font-bold">
                          ตำแหน่งในประโยค
                        </h3>
                        <div class="kt-infobox__content">
                          <span
                            v-for="(t, idx) in originalTokens"
                            :key="idx"
                            :class="t.color"
                          >
                            {{ t.text }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--End:: Portlet-->
          </div>
        </div>
      </div>
      <!-- end:: Content -->

      <!-- FeedbackModal -->
      <FeedbackModal :is-visible="isModalShow" />
    </div>
  </div>
</template>

<script>
import ws from '../ws'
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import FeedbackModal from '../components/FeedbackModal.vue'

export default {
  components: {
    FeedbackModal
  },
  data () {
    return {
      emails: [],
      originalTokens: [],
      textPool: [
        'อีเมลผู้เข้าประชุมคือ samart.s@gmail.com และ surachai.t@hotmail.com ค่ะ',
        'สอบถามเพิ่มเติมได้ที่ contact@insightera.co.th ครับ',
        'ระบบตรวจพบ email 1 รายการ ได้แก่ hellp@1palette.com ครับ'
      ],
      text: '',
      processing: false,
      countAnalyze: 0,
      isSentFeedback: false
    }
  },
  computed: {
    ...mapGetters(['sessionId', 'visitedPage']),
    isModalShow () {
      return (
        this.countAnalyze === 3 &&
        this.processing === false &&
        this.isSentFeedback !== true
      )
    }
  },
  mounted () {
    this.shuffle()
    this.random()
    this.id = this.sessionId
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    }),
    shuffle () {
      for (let i = this.textPool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this.textPool[i], this.textPool[j]] = [
          this.textPool[j],
          this.textPool[i]
        ]
      }
      return this.textPool
    },
    random () {
      if (this.textPool.length > 0) {
        this.text = this.textPool.shift()
        this.textPool.push(this.text)
        this.submit()
      }
    },
    debounceSubmit: _.debounce(
      function () {
        this.countAnalyze += 1
        this.check()
        // this.trackCustomEvent({ event: 'input', action: 'type', target: 'textarea_content', value: this.text })
        this.submit()
      },
      500,
      {
        leading: true
      }
    ),
    async submit (e) {
      this.processing = true
      const result = await ws.emailExtractor(this.text)

      const data = result.results[0]
      this.emails = data.emails.map(e => e.email)

      const tokens = []
      data.emails.map(email => {
        if (email.scope && email.scope[1] && email.scope[1] - email.scope[0] > 0) {
          tokens.push({
            data: email
          })
        }
      })

      tokens.sort((a, b) => {
        return a.data.scope[0] - b.data.scope[0]
      })

      this.originalTokens = []

      let index = 0
      for (const t of tokens) {
        if (index < t.data.scope[0]) {
          this.originalTokens.push({
            text: data.text.substring(index, t.data.scope[0]),
            color: ''
          })
          index = t.data.scope[1]
        }

        this.originalTokens.push({
          text: data.text.substring(t.data.scope[0], t.data.scope[1] + 1),
          color: 'kt-bg-success kt-font-light kt-padding-5'
        })
        index = t.data.scope[1] + 1
      }

      this.originalTokens.push({
        text: data.text.substring(index),
        color: ''
      })
      this.processing = false
    },
    input (e) {
      this.text = this.text.trim()
    },
    check () {
      Object.keys(this.visitedPage).map((key) => {
        if (key === this.$route.name) {
          this.isSentFeedback = true
        }
      })
    }
  }
}
</script>

<style scoped>
.kt-infobox__title {
  font-size: 22.75px;
}

.kt-infobox__content > span {
  line-height: 3rem;
}

.menu-button {
  padding-left: 20px;
  padding-right: 5px;
  /*width: 210px;*/
  text-align: left;
  color: #7a819e;
  margin: 1px 10px 1px 10px;
  background-color: transparent;
  position: relative;
  transition: 0.3s !important;
}

.menu-button:hover {
  color: rgba(111, 79, 255, 1);
}

.menu-button-active {
  padding-left: 20px;
  padding-right: 5px;
  /*width: 210px;*/
  text-align: left;
  color: #6e51fa;
  margin: 1px 10px 1px 10px;
  background-color: #f1edfe;
  font-weight: bold;
  position: relative;
}

.menu-button-active:after {
  content: "";
  position: absolute;
  top: 50%;
  margin-top: -15px;
  right: -25px;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid #f1edfe;
  border-right: 15px solid transparent;
}

.header-section {
  width: 100%;
}

.kt-subheader {
  height: auto;
  padding-bottom: 0 !important;
}

.service-header {
  margin-bottom: 15px;
}

.subtitle {
  color: white !important;
  font-size: 1.25rem;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 100%;
}

.api-doc {
  margin-top: 10px;
  margin-left: 20px;
}

.api-doc-link {
  color: #d4cafd;
  text-decoration: underline;
}

.check-box-icon {
  margin-right: 5px;
}

.service-info {
  display: flex;
  margin-bottom: 10px;
}

.btn-primary {
  background-color: #6e51fa;
  transition: 0.3s;
}

.btn-primary:hover {
  background-color: #533bb3;
}

.service-header .kt-container {
  padding: 0em 5em 0 5em;
}

.result.btn-pill {
  margin-bottom: 0.5em;
  margin-left: 0.5em;
}
</style>
